document.querySelectorAll('a[href^="https://cart.aaadriverprogram.com/cart/"]').forEach(item => {
  if (!item.href.includes('&tp=') && readCookie('_up4tp')) {
    item.href = item.href + '&tp=' + readCookie('_up4tp').toLowerCase();
  }
})
